import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService} from "../services";
import {ComponentTitleService} from "../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {CustomerMetricsService} from "./service/customerMetricsService";
import {FormControl, FormGroup} from "@angular/forms";
import {first} from "rxjs/operators";
import {MatDatepickerInputEvent} from "@angular/material/datepicker";
import {MultiSportReport} from "./models/multiSportReport";
import {MultiSportReportService} from "./service/multiSportReport.service";
import {MultiSportReportItems} from "./models/multiSportReportItems";
import {PzuSportReportService} from "./service/pzuSportReport.service";
import {PzuSportReportItems} from "./models/pzuSportReportItems";

@Component({
    templateUrl: './pzuSport.component.html',
    styleUrls: ['./pzuSport.component.scss']
})

export class PzuSportComponent implements OnDestroy, OnInit {
    dateRange: FormGroup;
    fastDate: string = 'lastWeek';
    reportData: MultiSportReport[];
    summary: number = 0;
    locale: string = 'pl';

    constructor(
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private customerMetricsService: CustomerMetricsService,
        private pzuSportReportService: PzuSportReportService,
    ) {
        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Reports');
        componentTitleService.addPart('PZU Sport');

        let today = new Date();

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-7))),
            end: new FormControl(new Date()),
        });
    }

    ngOnInit() {
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setDate(today.getDate()-7)));
        let end = this.convertDateToString(new Date());

        this.updateReportData(start, end);
    }

    ngOnDestroy(): void {

    }

    updateReportData(createdAt: string, createdAtTo: string): void {
        this.reportData = [];
        this.pzuSportReportService.get(createdAt, createdAtTo).pipe(first()).subscribe((res: PzuSportReportItems) => {
            this.summary = 0;
            this.reportData = res.items;

            for (let i=0; i<this.reportData.length; i++) {
                this.summary += this.reportData[i].quantity;

                let date = new Date(this.reportData[i].createdAt);
                this.reportData[i].timezoneOffset = date.getTimezoneOffset()/60;
            }
        });
    }

    convertDateToString(date: Date): string {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd
        ].join('-');
    };

    today() {
        this.fastDate = 'today';
        let start = this.convertDateToString(new Date());

        this.dateRange = new FormGroup({
            start: new FormControl(new Date()),
            end: new FormControl(new Date()),
        });

        this.updateReportData(start, start);
    }

    yesterday() {
        this.fastDate = 'yesterday';
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setDate(today.getDate()-1)));

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-1))),
            end: new FormControl(new Date(today.setDate(today.getDate()-1))),
        });

        this.updateReportData(start, start);
    }

    lastWeek() {
        this.fastDate = 'lastWeek';
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setDate(today.getDate()-7)));
        let end = this.convertDateToString(new Date());

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-7))),
            end: new FormControl(new Date()),
        });

        this.updateReportData(start, end);
    }

    lastMonth() {
        this.fastDate = 'lastMonth';
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setMonth(today.getMonth()-1)));
        let end = this.convertDateToString(new Date());

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-7))),
            end: new FormControl(new Date()),
        });

        this.updateReportData(start, end);
    }

    reloadStats(event: MatDatepickerInputEvent<any>) {
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setMonth(today.getMonth()-1)));
        let end = this.convertDateToString(new Date());

        try {
            start = this.dateRange.get('start').value.format('YYYY-MM-DD');
        } catch (e) {
            start = this.convertDateToString(this.dateRange.get('start').value);
        }

        try {
            end = this.dateRange.get('end').value.format('YYYY-MM-DD');
        } catch (e) {
            end = this.convertDateToString(this.dateRange.get('end').value);
        }

        this.updateReportData(start, end);
    }
}
